/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { WEBHOOK_NAME,WEBHOOK_URL,WEBHOOK_SECRET,WEBHOOK_SECRET_VALUE, WEBHOOK_NAME_ERROR, WEBHOOK_NAME_INVALID, ERR_INVALID_URL, WEBHOOK_SECRET_KEY_INVALID, WEBHOOK_SECRET_VALUE_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
import { TextField } from '@mui/material';
import { addWebhookConfig } from 'src/services/webhookconfigService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';
import { useSelector } from 'react-redux';
import type { RootState, WebhookFormInputs, WebhookApiResponse } from '../types/types';


interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

const validationSchema = Yup.object().shape({
    WebhookName: Yup.string().required(WEBHOOK_NAME_ERROR).matches(/^\S.*\S$|^\S$/, WEBHOOK_NAME_INVALID),
    URL: Yup.string().required('Please enter the webhook URL').matches(
            /^((http|https):\/\/)?(www\.)?(?!.*(http|https|www\.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\?.*)?$/gm,
            ERR_INVALID_URL
        ),
    SecretKey: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_KEY_INVALID),
    SecretValue: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_VALUE_INVALID),
});

function AddWebhookForm({closeModal, refreshPage}: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<WebhookFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
    });
    
    const onSubmit = async (data: WebhookFormInputs): Promise<void> => {
        data.CreatedBy =  user?.id ?? 0;
        data.ClientId = user?.clientId ?? 0;
        setIsLoading(true)
        await addWebhookConfig(data)
            .then(
                (res: WebhookApiResponse) => {
                    console.log(res)
                    if(res.status === 200) {
                        if(res.data.result === 1) {
                            
                            NotificationManager.success("Webhook added successfully")
                            refreshPage()
                        } else {
                            if(res.data.messages === "Unknown error has occurred ") {
                                
                                NotificationManager.error("Unknown error has occurred")
                            } 
                        } 
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                console.log("done")
                setIsLoading(false)
            })
    }

    return (
        <React.Fragment>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className="relative px-[16px] pt-[10px]">
                    <div className="mb-[30px]">
                        <Controller
                            name="WebhookName"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Webhook Name"
                                autoComplete="off"
                                InputProps={{
                                    inputProps: {
                                    style: {
                                        textAlign: "left",
                                        color: '#343434',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        WebkitTextFillColor: '#343434',
                                        padding: '9px 14px',
                                    },
                                    placeholder: `${WEBHOOK_NAME}`,
                                    },
                                }}
                                sx={{
                                    "& label": {
                                    textAlign: "center",
                                    },
                                    backgroundColor: "#F5F5F5",
                                }}
                                error={!!errors.WebhookName} // Set error state based on form validation
                                placeholder={WEBHOOK_NAME}
                                />
                                {errors.WebhookName && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.WebhookName?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>

                    <div className="mb-[30px]">
                        <Controller
                            name="URL"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Webhook URL"
                                autoComplete="off"
                                InputProps={{
                                    inputProps: {
                                    style: {
                                        textAlign: "left",
                                        color: '#343434',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        WebkitTextFillColor: '#343434',
                                        padding: '9px 14px',
                                    },
                                    placeholder: `${WEBHOOK_URL}`,
                                    },
                                }}
                                sx={{
                                    "& label": {
                                    textAlign: "center",
                                    },
                                    backgroundColor: "#F5F5F5",
                                }}
                                error={!!errors.URL} // Set error state based on form validation
                                placeholder={WEBHOOK_URL}
                                />
                                {errors.URL && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.URL?.message} 
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="SecretKey"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Secret Key"
                                autoComplete="off"
                                InputProps={{
                                    inputProps: {
                                    style: {
                                        textAlign: "left",
                                        color: '#343434',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        WebkitTextFillColor: '#343434',
                                        padding: '9px 14px',
                                    },
                                    placeholder: `${WEBHOOK_SECRET}`,
                                    },
                                }}
                                sx={{
                                    "& label": {
                                    textAlign: "center",
                                    },
                                    backgroundColor: "#F5F5F5",
                                }}
                                error={!!errors.SecretKey} // Set error state based on form validation
                                placeholder={WEBHOOK_SECRET}
                                />
                                {errors.SecretKey && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.SecretKey?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="SecretValue"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Secret Value"
                                autoComplete="off"
                                InputProps={{
                                    inputProps: {
                                    style: {
                                        textAlign: "left",
                                        color: '#343434',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        WebkitTextFillColor: '#343434',
                                        padding: '9px 14px',
                                    },
                                    placeholder: `${WEBHOOK_SECRET_VALUE}`,
                                    },
                                }}
                                sx={{
                                    "& label": {
                                    textAlign: "center",
                                    },
                                    backgroundColor: "#F5F5F5",
                                }}
                                error={!!errors.SecretValue} // Set error state based on form validation
                                placeholder={WEBHOOK_SECRET_VALUE}
                                />
                                {errors.SecretValue && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.SecretValue?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                    <div className="w-full relative col-span-3">
                        <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                    </div>
                    <div className="w-full relative col-span-3">
                        <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]">{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                    </div>
                </div>
            </form>


        </React.Fragment>
    )
}

export default AddWebhookForm